export default __webpack_public_path__ + "static/media/umbra.4980e7a0.svg";